import logo_blanco_mitad from './logo_blanco_mitad.png'
import user from './user.png'

export default {
    "logo_blanco_mitad": logo_blanco_mitad,
    "user": user
}